import actionTypes from '../constants/action-types';

const setSettings = () => ({
  type: actionTypes.SET_SETTINGS,
});

export default setSettings;
